<template>
  <div id="creator_agency_apply_details" :class="isFull === 1 ? 'creator_agency_apply_details top_information1' : ' creator_agency_apply_details'">
    <van-nav-bar :title="title" placeholder fixed @click-left="onClickLeft" left-arrow v-if="is_navigation_bar"/>
    <van-row>
      <van-col span="22" offset="1" class="creator_agency_apply_details_title">Agent Commission Rate</van-col>
      <van-col span="22" offset="1" class="creator_agency_apply_details_rule">
        <van-col span="24" class="creator_agency_apply_details_rule_center">
          <van-col span="5" class="creator_agency_apply_details_rule_center_name">Level</van-col>
          <van-col span="6" class="creator_agency_apply_details_rule_center_r_name">Creator Earnings </van-col>
          <van-col span="6" class="creator_agency_apply_details_rule_center_r_name">Rates</van-col>
          <van-col span="7" class="creator_agency_apply_details_rule_center_r_name">Agency Commission</van-col>
        </van-col>
        <van-col span="24" class="creator_agency_apply_details_rule_list" v-for="(item,i) in list" :key="i">
          <van-col span="4" class="creator_agency_apply_details_rule_list_name">{{ item.level_name }}</van-col>
          <van-col span="7" class="creator_agency_apply_details_rule_list_r_name">  <img src="../assets/img/coin9.png"/> {{ item.min_coin_text }}</van-col>
          <van-col span="6" class="creator_agency_apply_details_rule_list_r_name">{{ item.rate_text }}</van-col>
          <van-col span="7" class="creator_agency_apply_details_rule_list_r_name creator_agency_apply_details_rule_list_r_color"><img src="../assets/img/coin9.png"/> {{ item.reward_text }}</van-col>
        </van-col>


      </van-col>
      <van-col span="24">
        <div style="padding:15px;" v-html="content"></div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
export default {
  data() {
    return {
      content: undefined,
      title: undefined,
      list: [],
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      is_navigation_bar: false,
    }
  },
  created() {
     this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.is_navigation_bar = this.$route.query.is_navigation_bar == 1 ? true : false // 是否展示顶部导航栏
    this.getList()
  },
  methods: {
    getList(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_application_explain",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.title = res.data.data.article.title
          if (this.is_navigation_bar == false) {
            document.title = this.title
          }
          this.content = res.data.data.article.content
          this.list = res.data.data.list
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1); // 返回上一页
    },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creator_agency_apply_details.vue